module.exports = __webpack_public_path__ + "static/media/document.1ba977e8.svg";